class PasswordShower {

    constructor(config) {
        this.config = Object.assign({
            scope: '.password-show',
            input: 'input',
            icon: '.icon-show-hide',
        }, config);

        this.$scope = $(this.config.scope);

        if(this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.$scope.on("click", this.config.icon, (event) => {
            let $target = $(event.currentTarget);
            let $parent = $target.closest(this.config.scope);
            let $input = $parent.find(this.config.input);
            if ($input[0].type === "password") {
                $input.attr("type", "text");
                $target.removeClass('icon-eye').addClass('icon-eye-off')
                    .attr('title', 'Wachtwoord verbergen');
            } else {
                $input.attr("type", "password");
                $target.removeClass('icon-eye-off').addClass('icon-eye')
                    .attr('title', 'Wachtwoord tonen');
            }
        });
    }
}

export default new PasswordShower
